fbm.add("terminal", ["util/ui", "util/screens", "util/io", "util/pause", "commands/connect", "commands/login"], function (uui, uscreens, uio, upause, cconnect, clogin) {

    let {
        registerHandlers,
        enableTyping,
        type,
        pause,
        clear,
        power,
        login,
        clearKey,

    } = {
        ...uui,
        ...uscreens,
        ...uio,
        ...upause,
        ...cconnect,
        ...clogin,
    }

    const $bg = document.querySelector(".computer");
    const $crt = document.querySelector("#crt");
    const fullFontBase = 24;
    const mobileFontBase = 18.5;
    const mobileMaxWidth = 590;

    async function onLoad() {
        setTimeout(function(){
            sizeTheScreen()
            document.getElementById('crt').style.opacity = 1;
            document.getElementById('crt').style.transform = "scale(1)";
        },1000);

        // Set up click event handlers for UI buttons
        registerHandlers();

        await clear();
        enableTyping(true);

        await power();

        await type(["Welcome to Evolved Apes Inc. secure terminal running Gibbon v1.337", "  Copyright © 1973-1978 Cavendish Security Systems Intl"], {
            initialWait: 100,
            lineWait: 100,
            wait: 10
        });

        await type(["\n> BEGIN SECURE BOOT"], {
            lineWait: 100,
            wait: 10
        });
        await type(
            [
                "> MEMORY TEST",
                "    128k",
                "    256k",
                "    512k",
                "    640k",
                "  (that should be enough for anybody)         --PASS--",
            ],
            {lineWait: 200}
        );
        await pause(.35);
        await type(["> ENABLING MIDDLE-OUT COMPRESSION PROTOCOLS   --FAIL--", "> ENABLING ARTIFACT (L) EDGE® DRIVERS         --WARN--", "   ! Artifact signal interference detected at 2600hz"]);
        await pause(1);

        return login();
    }

    function sizeTheScreen() {
        const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
        if (vw > mobileMaxWidth) {
            let realWidth = $bg.naturalWidth;
            let currWidth = $bg.clientWidth;
            // change the font size at the same ratio as the background
            let adjFontSize = fullFontBase * (currWidth / realWidth);
            $crt.style.fontSize =  adjFontSize + "px";

            if (vw < currWidth) {
                //once we hit the min width for the image... start moving the image to the left.
                // we do this at half speed so that it crops evenly on both sides
                $bg.style.transform = 'translateX(-' + ((currWidth - vw) / 2) + 'px)';
            } else {
                //needed if the screen is resized faster than the browser thinks
                $bg.style.transform = 'translateX(0)';
            }
            $crt.style.display = "";
        } else {
            let adjFontSize = mobileFontBase * (vw / mobileMaxWidth);
            $crt.style.fontSize = adjFontSize + "px";
            $crt.style.display = "";
        }
    }



    window.addEventListener('resize', sizeTheScreen);

    return {
        default: function powerOn(config) {
            config = Object.assign({captcha: "", magic: "mike", network: "MainNet", contract : "0x0000000000000000000000000000000000000000", ea: "0x0000000000000000000000000000000000000000" }, config)

            let m = document.getElementById("monitor");
            m.classList.remove("off");
            m.classList.add("on");

            window.fbaConfig = config;
            window.dazeth = new DazEth(config.network, {}, true);

            onLoad().then(() => {
            });
        },
        sizeTheScreen,
    }
});
